export const CATEGORY_IMAGES = {
  epdm: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?auto=format&fit=crop&w=800&q=80",
  tpo: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=800&q=80",
  pvc: "https://images.unsplash.com/photo-1487958449943-2429e8be8625?auto=format&fit=crop&w=800&q=80",
  fleece: "https://images.unsplash.com/photo-1449157291145-7efd050a4d0e?auto=format&fit=crop&w=800&q=80",
  insulation: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=800&q=80",
  accessories: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?auto=format&fit=crop&w=800&q=80",
  modbit: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=800&q=80",
};

// Official manufacturer product photos hosted locally in /public/products/.
// Carlisle SynTec and Versico photos were captured from their official product
// pages; Johns Manville and Elevate from their official sites/DAM. GAF and Sika
// hard-block all third-party fetching (403/Access Denied at page level), so
// their products render the labeled placeholder until official files are supplied.
export const PRODUCT_IMAGES = {
  // Carlisle SynTec (official product images via carlislesyntec.com)
  "sure-seal-epdm": "/products/sure-seal-epdm.png",
  "sure-white-epdm": "/products/sure-white-epdm.png",
  "fleeceback-epdm": "/products/fleeceback-epdm.png",
  "sure-weld-tpo": "/products/sure-weld-tpo.png",
  "sure-flex-pvc": "/products/sure-flex-pvc.png",
  "sure-weld-tpo-fleeceback": "/products/sure-weld-tpo-fleeceback.png",
  "sure-flex-pvc-fleeceback": "/products/sure-flex-pvc-fleeceback.png",
  "securshield-hd": "/products/securshield-hd.png",
  "sure-seal-flashing": "/products/sure-seal-flashing.png",
  "fast-fasteners": "/products/fast-fasteners.jpg",
  // Versico (official, versico.com)
  "versigard-epdm": "/products/versigard-epdm.png",
  "versiweld-tpo": "/products/versiweld-tpo.png",
  "versiflex-pvc": "/products/versiflex-pvc.png",
  // Johns Manville (official, jm.com)
  "jm-epdm": "/products/jm-epdm.jpg",
  "jm-tpo": "/products/jm-tpo.jpg",
  "jm-pvc": "/products/jm-pvc.jpg",
  "enrgy-3-polyiso": "/products/enrgy-3-polyiso.png",
  "protector-hd": "/products/protector-hd.jpg",
  // Elevate (official, holcimelevate.com)
  "rubbergard-epdm": "/products/rubbergard-epdm.jpg",
  "ultraply-tpo": "/products/ultraply-tpo.jpg",
  "isogard-polyiso": "/products/isogard-polyiso.jpg",
  // Sika Sarnafil (official, usa.sika.com)
  "sarnafil-g410": "/products/sarnafil-g410.png",
  "sikaplan-adhered": "/products/sikaplan-adhered.png",
  // GAF (official, product-assets.gaf.com via archive)
  "everguard-tpo": "/products/everguard-tpo.jpg",
  "energyguard-polyiso": "/products/energyguard-polyiso.jpg",
  "ruberoid-modified-bitumen": "/products/ruberoid-modified-bitumen.jpg",
  // No verified official photo available yet (labeled placeholder shown):
  // insulbase-polyiso, cav-grip-iii, sure-seal-primer, everguard-extreme-tpo
};

// Official manufacturer product page for each product (detail pages link out).
export const OFFICIAL_URLS = {
  "sure-seal-epdm": "https://www.carlislesyntec.com/en/Roofing-Products/Membranes/EPDM/Sure-Seal",
  "sure-white-epdm": "https://www.carlislesyntec.com/en/Roofing-Products/Membranes/EPDM",
  "fleeceback-epdm": "https://www.carlislesyntec.com/en/Roofing-Products/Membranes/FleeceBACK",
  "rubbergard-epdm": "https://holcimelevate.com/uk-en/roofing/epdm/rubbergard-epdm",
  "jm-epdm": "https://www.jm.com/en/commercial-roofing/epdm-roofing-systems/",
  "versigard-epdm": "https://www.versico.com/en/Roofing-Products/Membranes/EPDM/VersiGard",
  "sure-weld-tpo": "https://www.carlislesyntec.com/en/Roofing-Products/Membranes/TPO/Sure-Weld",
  "ultraply-tpo": "https://holcimelevate.com/uk-en/roofing/tpo/ultraply-tpo",
  "everguard-tpo": "https://www.gaf.com/en-us/roofing-materials/commercial-roofing-materials/tpo-membranes/everguard-tpo-smooth-membranes",
  "everguard-extreme-tpo": "https://www.gaf.com/en-us/roofing-materials/commercial-roofing-materials/tpo-membranes/everguard-tpo-extreme-smooth-membranes",
  "jm-tpo": "https://www.jm.com/en/commercial-roofing/tpo-roofing-systems/",
  "versiweld-tpo": "https://www.versico.com/en/Roofing-Products/Membranes/TPO/VersiWeld-Reinforced",
  "sure-flex-pvc": "https://www.carlislesyntec.com/en/Roofing-Products/Membranes/PVC/Sure-Flex",
  "jm-pvc": "https://www.jm.com/en/commercial-roofing/pvc-roofing-systems/",
  "versiflex-pvc": "https://www.versico.com/en/Roofing-Products/Membranes/PVC/VersiFlex",
  "sarnafil-g410": "https://usa.sika.com/sarnafil/en/pvc-roofing/membranes/roofing-membranes/sarnafil-g-410-80.html",
  "sikaplan-adhered": "https://usa.sika.com/sarnafil/en/pvc-roofing/membranes/roofing-membranes.html",
  "sure-weld-tpo-fleeceback": "https://www.carlislesyntec.com/en/Roofing-Products/Membranes/FleeceBACK",
  "sure-flex-pvc-fleeceback": "https://www.carlislesyntec.com/en/Roofing-Products/Membranes/FleeceBACK",
  "insulbase-polyiso": "https://www.carlislesyntec.com/en/Roofing-Products/Other-Components/Insulation/Polyiso/InsulBase",
  "securshield-hd": "https://www.carlislesyntec.com/en/Roofing-Products/Other-Components/Insulation/SecurShield-HD",
  "energyguard-polyiso": "https://www.gaf.com/en-us/roofing-materials/commercial-roofing-materials/insulation/energyguard-polyiso-insulation",
  "enrgy-3-polyiso": "https://www.jm.com/en/commercial-roofing/roofing-insulation-and-cover--boards/",
  "protector-hd": "https://www.jm.com/en/commercial-roofing/roofing-insulation-and-cover--boards/protector-hd/",
  "isogard-polyiso": "https://holcimelevate.com/uk-en/roofing/insulation/isogard-hd",
  "cav-grip-iii": "https://www.carlislesyntec.com/Roofing-Products/Other-Components/Adhesives-Primers-Sealants/CAV-GRIP",
  "sure-seal-primer": "https://www.carlislesyntec.com/Roofing-Products/Other-Components/Adhesives-Primers-Sealants/EPDM-Primer",
  "fast-fasteners": "https://www.carlislesyntec.com/Roofing-Products/Other-Components/Plates-and-Fasteners/FAST",
  "sure-seal-flashing": "https://www.carlislesyntec.com/Roofing-Products/Other-Components/Flashings-and-Accessories/EPDM-Flashing",
  "ruberoid-modified-bitumen": "https://www.gaf.com/en-us/roofing-materials/commercial-roofing-materials/asphaltic-membranes/ruberoid-mop-smooth-membrane",
};

export const CATEGORIES = [
  { slug: "epdm", label: "EPDM Roofing Membranes" },
  { slug: "tpo", label: "TPO Roofing Membranes" },
  { slug: "pvc", label: "PVC Roofing Membranes" },
  { slug: "fleece", label: "Fleece-Backed Roofing Systems" },
  { slug: "insulation", label: "Roof Insulation & Cover Boards" },
  { slug: "accessories", label: "Roofing Accessories" },
  { slug: "modbit", label: "Modified Bitumen" },
];

export const MANUFACTURERS = [
  "Carlisle SynTec",
  "GAF",
  "Johns Manville",
  "Elevate",
  "Sika Sarnafil",
  "Versico",
];

export const PRODUCTS = [
  // --- EPDM Roofing Membranes ---
  {
    slug: "sure-seal-epdm",
    name: "Sure-Seal EPDM",
    manufacturer: "Carlisle SynTec",
    category: "epdm",
    material: "EPDM synthetic rubber membrane",
    applications: "Flat roofs, commercial buildings, extensions and industrial roofing",
    blurb: "Carlisle's flagship black EPDM membrane with decades of proven field performance.",
  },
  {
    slug: "sure-white-epdm",
    name: "Sure-White EPDM",
    manufacturer: "Carlisle SynTec",
    category: "epdm",
    material: "White-on-black EPDM membrane",
    applications: "Commercial flat roofs where a reflective surface is preferred",
    blurb: "Combines EPDM durability with a reflective white surface.",
  },
  {
    slug: "fleeceback-epdm",
    name: "FleeceBACK EPDM",
    manufacturer: "Carlisle SynTec",
    category: "epdm",
    material: "Fleece-reinforced EPDM membrane",
    applications: "Adhered roofing systems on commercial buildings",
    blurb: "Polyester fleece backing adds toughness and enables adhered installation.",
  },
  {
    slug: "rubbergard-epdm",
    name: "RubberGard EPDM",
    manufacturer: "Elevate",
    category: "epdm",
    material: "EPDM synthetic rubber membrane",
    applications: "Low-slope commercial and industrial roofs",
    blurb: "Elevate's EPDM line (formerly Firestone Building Products).",
  },
  {
    slug: "jm-epdm",
    name: "JM EPDM",
    manufacturer: "Johns Manville",
    category: "epdm",
    material: "EPDM synthetic rubber membrane",
    applications: "Flat and low-slope commercial roofing",
    blurb: "Johns Manville EPDM membranes for weather-resistant roof systems.",
  },
  {
    slug: "versigard-epdm",
    name: "VersiGard EPDM",
    manufacturer: "Versico",
    category: "epdm",
    material: "EPDM synthetic rubber membrane",
    applications: "Commercial flat roofs and re-roofing projects",
    blurb: "Versico's EPDM membranes in black and white options.",
  },
  // --- TPO Roofing Membranes ---
  {
    slug: "sure-weld-tpo",
    name: "Sure-Weld TPO",
    manufacturer: "Carlisle SynTec",
    category: "tpo",
    material: "Heat-weldable TPO membrane",
    applications: "Commercial and industrial flat roofs",
    blurb: "Heat-welded seams and a reflective surface for energy-efficient roofs.",
  },
  {
    slug: "ultraply-tpo",
    name: "UltraPly TPO",
    manufacturer: "Elevate",
    category: "tpo",
    material: "Thermoplastic polyolefin (TPO) membrane",
    applications: "Low-slope commercial roofs",
    blurb: "Elevate's flexible TPO membrane with heat-weldable seams.",
  },
  {
    slug: "everguard-tpo",
    name: "EverGuard TPO",
    manufacturer: "GAF",
    category: "tpo",
    material: "TPO single-ply membrane",
    applications: "Commercial flat roofs",
    blurb: "GAF's widely specified TPO membrane line.",
  },
  {
    slug: "everguard-extreme-tpo",
    name: "EverGuard Extreme TPO",
    manufacturer: "GAF",
    category: "tpo",
    material: "High-performance TPO membrane",
    applications: "Demanding commercial and industrial roofs",
    blurb: "Engineered for enhanced long-term heat and UV exposure.",
  },
  {
    slug: "jm-tpo",
    name: "JM TPO",
    manufacturer: "Johns Manville",
    category: "tpo",
    material: "TPO single-ply membrane",
    applications: "Commercial and industrial roofing",
    blurb: "Johns Manville TPO membranes with heat-welded seam strength.",
  },
  {
    slug: "versiweld-tpo",
    name: "VersiWeld TPO",
    manufacturer: "Versico",
    category: "tpo",
    material: "TPO single-ply membrane",
    applications: "Flat roofs, re-roofs, and new construction",
    blurb: "Versico's reflective TPO membrane systems.",
  },
  // --- PVC Roofing Membranes ---
  {
    slug: "sure-flex-pvc",
    name: "Sure-Flex PVC",
    manufacturer: "Carlisle SynTec",
    category: "pvc",
    material: "PVC single-ply membrane",
    applications: "Restaurants, industrial facilities, and roofs with grease or chemical exposure",
    blurb: "PVC membrane suited to harsh rooftop environments.",
  },
  {
    slug: "jm-pvc",
    name: "JM PVC",
    manufacturer: "Johns Manville",
    category: "pvc",
    material: "PVC single-ply membrane",
    applications: "Commercial roofs exposed to chemicals or grease",
    blurb: "Johns Manville PVC membranes for demanding conditions.",
  },
  {
    slug: "versiflex-pvc",
    name: "VersiFlex PVC",
    manufacturer: "Versico",
    category: "pvc",
    material: "PVC single-ply membrane",
    applications: "Commercial and industrial buildings",
    blurb: "Versico PVC membranes with heat-welded seams.",
  },
  {
    slug: "sarnafil-g410",
    name: "Sarnafil G 410",
    manufacturer: "Sika Sarnafil",
    category: "pvc",
    material: "Felt-backed thermoplastic (PVC) membrane",
    applications: "Adhered commercial roof systems",
    blurb: "Sika Sarnafil's flagship thermoplastic roofing membrane.",
  },
  {
    slug: "sikaplan-adhered",
    name: "Sikaplan Adhered",
    manufacturer: "Sika Sarnafil",
    category: "pvc",
    material: "PVC single-ply membrane",
    applications: "Cost-conscious commercial roofing projects",
    blurb: "Sika's value-engineered adhered PVC roof system.",
  },
  // --- Fleece-Backed Roofing Systems ---
  {
    slug: "sure-weld-tpo-fleeceback",
    name: "Sure-Weld TPO FleeceBACK",
    manufacturer: "Carlisle SynTec",
    category: "fleece",
    material: "Fleece-backed TPO membrane",
    applications: "Adhered commercial roofing systems",
    blurb: "TPO performance with Carlisle's fleece backing for adhered installation.",
  },
  {
    slug: "sure-flex-pvc-fleeceback",
    name: "Sure-Flex PVC FleeceBACK",
    manufacturer: "Carlisle SynTec",
    category: "fleece",
    material: "Fleece-backed PVC membrane",
    applications: "Adhered systems needing chemical resistance",
    blurb: "PVC membrane with Carlisle's fleece backing for added durability.",
  },
  // --- Roof Insulation & Cover Boards ---
  {
    slug: "insulbase-polyiso",
    name: "InsulBase Polyiso",
    manufacturer: "Carlisle SynTec",
    category: "insulation",
    material: "Polyisocyanurate roof insulation",
    applications: "Commercial flat roof assemblies",
    blurb: "Rigid foam insulation boards for commercial roof systems.",
  },
  {
    slug: "securshield-hd",
    name: "SecurShield HD Cover Board",
    manufacturer: "Carlisle SynTec",
    category: "insulation",
    material: "High-density polyiso cover board",
    applications: "Installed over insulation, beneath the membrane",
    blurb: "Adds impact and foot-traffic resistance to the roof assembly.",
  },
  {
    slug: "energyguard-polyiso",
    name: "EnergyGuard Polyiso",
    manufacturer: "GAF",
    category: "insulation",
    material: "Polyisocyanurate roof insulation",
    applications: "Commercial roof systems",
    blurb: "GAF's polyiso roof insulation board line.",
  },
  {
    slug: "enrgy-3-polyiso",
    name: "ENRGY 3 Polyiso",
    manufacturer: "Johns Manville",
    category: "insulation",
    material: "Polyisocyanurate roof insulation",
    applications: "Flat and low-slope roof assemblies",
    blurb: "Johns Manville's polyiso roof insulation.",
  },
  {
    slug: "protector-hd",
    name: "ProtectoR HD Cover Board",
    manufacturer: "Johns Manville",
    category: "insulation",
    material: "High-density polyisocyanurate cover board",
    applications: "Above insulation, below the membrane in commercial roof assemblies",
    blurb: "Johns Manville's high-density polyiso cover board for added roof system protection.",
  },
  {
    slug: "isogard-polyiso",
    name: "ISOGARD Polyiso",
    manufacturer: "Elevate",
    category: "insulation",
    material: "Polyisocyanurate roof insulation",
    applications: "Commercial roof assemblies",
    blurb: "Elevate's polyiso insulation boards.",
  },
  // --- Roofing Accessories ---
  {
    slug: "cav-grip-iii",
    name: "CAV-GRIP III Adhesive",
    manufacturer: "Carlisle SynTec",
    category: "accessories",
    material: "Low-VOC aerosol bonding adhesive",
    applications: "Membrane and insulation attachment",
    blurb: "Spray-applied adhesive for single-ply roofing systems.",
  },
  {
    slug: "sure-seal-primer",
    name: "Sure-Seal Primer",
    manufacturer: "Carlisle SynTec",
    category: "accessories",
    material: "EPDM splice primer",
    applications: "Seam and flashing preparation",
    blurb: "Prepares EPDM surfaces for tapes and adhesives.",
  },
  {
    slug: "fast-fasteners",
    name: "FAST Fasteners & Plates",
    manufacturer: "Carlisle SynTec",
    category: "accessories",
    material: "Roofing fasteners and insulation plates",
    applications: "Mechanically attached roofing systems",
    blurb: "Fasteners and plates for membrane and insulation attachment.",
  },
  {
    slug: "sure-seal-flashing",
    name: "Sure-Seal EPDM Flashing",
    manufacturer: "Carlisle SynTec",
    category: "accessories",
    material: "Uncured EPDM flashing",
    applications: "Penetrations, corners, and edge details",
    blurb: "Moldable flashing for watertight roof detailing.",
  },
  // --- Modified Bitumen ---
  {
    slug: "ruberoid-modified-bitumen",
    name: "RUBEROID Modified Bitumen",
    manufacturer: "GAF",
    category: "modbit",
    material: "SBS modified bitumen membrane",
    applications: "Low-slope commercial roofs",
    blurb: "GAF's asphalt-based multi-ply membrane line.",
  },
];

export const getCategoryLabel = (slug) =>
  CATEGORIES.find((c) => c.slug === slug)?.label || slug;
